import React, { useState, useEffect, Fragment, useRef } from 'react'
import { Table, Row, Col, Input, Spin, Tree, message, Button } from "antd";
import { CaretDownOutlined, DownloadOutlined } from '@ant-design/icons';
import ReportApi from '@api/report'
import StationApi from '@api/station'
import SearchForm from '@components/SearchForm'
import Pover from '@/components/Pover'
import Title from '@/components/Title'
import moment from "moment"
import './../style.scss'
const { Search } = Input

export default ({ history }) => {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([]) // 表格数据
    const [columns, setColumns] = useState([])
    const [treeData, setTreeData] = useState([]) // 表格数据
    const [hasArea, setHasArea] = useState(false)
    const [selectedKey, setSelectedKey] = useState([])
    const [defaultKeys, setDefaultKeys] = useState("")

    // 搜索相关参数 
    const [searchParams, setSearchParams] = useState({
        pageNum: 1,
        pageSize: 10,
        stationId: null,
    })

    // 搜索
    const [dateSearch] = useState([{
        name: "timeStart",
        label: "操作日期",
        message: "请选择站点",
        tag: "rangePicker",
        picker: "year",
        span: 10,
        labelCol: 5
    }])

    useEffect(() => {
        if (selectedKey.length > 0) {
            getListByPage()
        }
        return () => { }
    }, [searchParams])

    useEffect(() => {
        findDevicesWithArea()
        return () => { }
    }, [])

    const findDevicesWithArea = () => {
        setLoading(true)
        StationApi.findStationsWithArea({}).then(res => {
            setLoading(false)
            if (res.status == 0 && res.data) {
                setHasArea(true)
                matchData(res.data)
                setTreeData(res.data)
            }
        })
    }

    const matchData = (data) => {
        data.map((item, index) => {
            if (item.children && item.children.length) {
                item.key = `key${item.children[0].admRegionId}${index}`
                //item.disabled = true
                matchData(item.children)
            } else {
                item.key = item.id
                item.title = Pover(item.name, 8)
            }
        })
    }

    const onSelect = (selectedKeys, key) => {
        selectedKeys = selectedKeys.filter(item => !(`${item}`).includes("key"))
        if (selectedKeys.length) {
            setSelectedKey(selectedKeys)
            setSearchParams({
                ...searchParams,
                stationIds: selectedKeys
            })
        } else {
            setData([])
            setColumns([])
            setSelectedKey([])
        }
    };

    const onSearch = (e) => {
        setDefaultKeys(null)
        treeData.map(item => {
            item.children.map(it => {
                if (it.title == e) {
                    setDefaultKeys(it.key)
                }
            })
        })
    }


    const getListByPage = () => {

        ReportApi.queryStationDataByType({ ...searchParams, stationIds: selectedKey, type: 3 }).then(res => {
            if (res.status == 0) {

                let tempColumns = []
                let tempData = []

                res.data.data.map((item) => {
                    item.data.map(it => {
                        tempData.push({
                            ...it,
                            mergeNum: item.data.length
                        })
                    })
                })

                res.data.data = tempData

                let arr = res.data.title
                if (arr) {
                    for (let a in arr) {
                        tempColumns.push({
                            title: arr[a],
                            dataIndex: a,
                            align: 'center',
                            key: a,
                            fixed: (a == "collectTime" || a == "stationName") ? "left" : null,
                            render: (text, record, index) => {
                                if (a == "collectTime") {
                                    // 单元格合并
                                    const obj = {
                                        children: text,
                                        props: {},
                                    }
                                    if (tempData.length > 0) {
                                        obj.props.rowSpan = mergeCells(text, tempData, "collectTime", index)
                                    }
                                    return obj
                                } else {
                                    return text
                                }
                            }
                        })
                    }
                }

                setData(res.data)
                setColumns(tempColumns)
            }
        })
    }

    const mergeCells = (text, data, key, index) => {
        //上一行该列数据是否一样
        if (index !== 0 && data[index] && text === data[index - 1][key]) {
            return 0
        }
        let rowSpan = 1
        // 判断下一行是否相等
        for (let i = index + 1; i < data.length; i++) {
            if (text !== data[i][key]) {
                break
            }
            rowSpan++
        }
        return rowSpan
    }

    // 分页
    const handleTableChange = (pagination) => {
        setSearchParams({
            ...searchParams,
            pageNum: pagination.current,
            pageSize: pagination.pageSize,
        })
    };

    /**
     * 搜索
     * @param params
     */
    const search = (params) => {
        if (selectedKey.length < 1) {
            message.warning("请先输入站点名称！")
            return
        } else if (!params.timeStart) {
            message.warning("请先选择时间范围！")
            return
        }
        setSearchParams({
            ...params,
            startTime: params.timeStart ? moment(params.timeStart[0]).format("YYYY") : null,
            endTime: params.timeStart ? moment(params.timeStart[1]).format("YYYY") : null,
            pageNum: 1,
            pageSize: 10,
        })
    }


    const onRest = () => {
        setSearchParams({
            pageNum: 1,
            pageSize: 10,
            type: 3
        })
    }

    const addConfig = () => {
        ReportApi.exportByQuery({ ...searchParams, stationIds: selectedKey, type: 3 }).then(res => {
            let a = document.createElement('a');
            let blob = new Blob([res], { type: "application/vnd.ms-excel" });
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", '年报表.xls');
            a.click();
        })
    }

    return (
        <div className='baseContent'>
            <Title title="年报表"></Title>
            <Row>
                <Col
                    span={5}
                    key="1"
                    style={{
                        maxHeight: "646px",
                        overflow: "auto",
                        borderRight: "1px solid #ccc"
                    }}
                >
                    <div className="search-container">
                        <Search
                            placeholder="请输入站点"
                            enterButton
                            onSearch={onSearch}
                        />
                    </div>
                    {treeData.length ? (
                        <Tree
                            showLine
                            checkable
                            switcherIcon={<CaretDownOutlined style={{ fontSize: "16px" }} />}
                            style={{ overflow: "scroll", width: "100%" }}
                            defaultExpandAll
                            selectedKeys={[defaultKeys]}
                            onCheck={onSelect}
                            treeData={treeData}
                        >
                        </Tree>
                    ) : hasArea ? (
                        <div
                            style={{
                                textAlign: "center",
                                marginTop: "20px",
                                color: "#000",
                                fontSize: "16px"
                            }}
                        >
                            暂无数据!
                        </div>
                    ) : <div
                        style={{
                            width: "100%",
                            padding: "10px 0 0 calc(50% - 10px)"
                        }}
                    >
                                <Spin />
                            </div>}
                </Col>
                <Col span={19} style={{ paddingLeft: "12px" }}>
                    <SearchForm span={6} dateSearch={dateSearch} onSearch={search} onRest={onRest} />
                    <div style={{ marginTop: "12px" }} className='mb10 mt24'>
                        <Button disabled={selectedKey.length < 1} style={{ background: "#31d5df", border: "1px solid #31d5df" }} icon={<DownloadOutlined />} type='primary' size="large" onClick={addConfig}>导出</Button>
                    </div>
                    <div style={{ marginTop: "18px" }}>
                        <Table
                            columns={columns}
                            dataSource={data.data}
                            bordered
                            rowKey={record => record.id}
                            scroll={{ x: columns.length * 118, y: 450 }}
                            pagination={{
                                current: data.pageNum,
                                pageSize: data.pageSize,
                                showQuickJumper: true,
                                showSizeChanger: true,
                                showTotal: total => `共${total}条数据`,
                                total: data.total
                            }}
                            onChange={handleTableChange}
                            loading={loading}
                        />
                    </div>
                </Col>
            </Row>

        </div >
    )
}
